import _ from 'lodash';

import Cookies from 'js-cookie';

import { ContextBarContent, DEFAULT_CONTENT_PRIORITY } from './content.js';

import BarTemplate from '../templates/content-pwa-ios-guide.html';

const COOKIE_BAR_DISMISSED_NAME = 'pwa-ios-guide-dismissed';

export class ContentPwaIosGuideBar extends ContextBarContent {
	constructor (options) {
		options = _.defaultsDeep(options || {},
			{
				name: 'pwa-ios-guide',
				above: ['default'],
			}
		);
		super(options);

		this.priority = DEFAULT_CONTENT_PRIORITY;

		this.template = {
			html: BarTemplate(),
			data: this,
		};
	}

	static isDismissedByUser = () => Boolean(Cookies.get(COOKIE_BAR_DISMISSED_NAME));

	beforeRemove = () => {
		const sixHours = 0.25;
		Cookies.set(
			COOKIE_BAR_DISMISSED_NAME,
			true,
			{ expires: sixHours, path: '/' }
		);
	}
}